module.exports = __webpack_public_path__ + "static/media/icon-edit-black.d602785b.svg";